import React from 'react'
import { IconProps } from './interfaces/IconProps.interface'

const Stopwatch = ({ color, ...props }: IconProps) => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path d="M11.745 3.9785L12.7137 3.00984L13.6564 3.9525L12.6877 4.92117C13.6449 6.11928 14.107 7.63842 13.9791 9.16659C13.8512 10.6948 13.143 12.116 12 13.1383C10.857 14.1607 9.36596 14.7066 7.83304 14.6639C6.30012 14.6212 4.84172 13.9932 3.75736 12.9089C2.673 11.8245 2.045 10.3661 2.00233 8.83318C1.95965 7.30026 2.50555 5.80918 3.5279 4.66618C4.55025 3.52317 5.97145 2.81501 7.49963 2.68712C9.0278 2.55923 10.5469 3.02132 11.745 3.9785ZM7.33305 5.33317V9.33317H8.66638V5.33317H7.33305ZM5.33305 0.666504H10.6664V1.99984H5.33305V0.666504Z" fill={color || "#000"} />
        </svg>
    )
}

export default Stopwatch